// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__BRqR3","row":"styles_row__1r2JS"};